import React from 'react'
import {
    Col,
    Panel,
    Row,
    Button,
    FormControl,
    Glyphicon
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faSearch } from '@fortawesome/free-solid-svg-icons'

import SiteSearchFilters from './SiteSearchFilters'
import FrogPlayPopover from './FrogPlayPopover'
import YearPopover from './YearPopover'

export default class BoostSiteFilterMobile extends React.Component {
    render() {

        const stickyStyle = this.props.isFilterShow ? {
            position: 'fixed',
            top: 0,
            zIndex: 10,
            width: '100%'
        } : null;

        const filterStr = window.innerWidth >= 375 ? 'Filter' : '';

        const { selectedSubject, selectedYear, selectedLearningSkill, selectedContentStandard } = this.props.curriculum
        const isFilter = selectedSubject !== null || selectedYear !== null || selectedLearningSkill !== null || selectedContentStandard !== null
        const cssIndicator = isFilter ? {
            width: '100%',
            borderBottomWidth: 5,
            borderBottomColor: '#158cba',
            borderBottomStyle: 'solid'
        } : { width: '100%' }

        return (
            <div id="lesson-head-sticky" style={stickyStyle}>
                <div className="panel" style={{ marginBottom: 0 }}>
                    <div id="lesson-head" className="container container-fluid">
                        <Row style={{ marginLeft: '0px', marginRight: '0px', paddingTop: 20, paddingBottom: 20 }}>
                            <Col md={3} xs={3} style={{paddingRight: 0, textAlign: 'right'}}>
                                <Button
                                    type="button" 
                                    bsStyle="default" 
                                    onClick={this.props.toggleFilter} 
                                    style={cssIndicator}>
                                    <FontAwesomeIcon icon={faFilter} /> {filterStr}
                                </Button>
                            </Col>
                            <Col md={7} xs={7}>
                                <FormControl
                                    type="text"
                                    size={40}
                                    value={this.props.query}
                                    placeholder="Search for a site"
                                    onChange={this.props.handleSearchChange}
                                />
                                {this.props.query.length > 1 &&
                                <Glyphicon
                                    onClick={this.props.handleSearchClear}
                                    className="input-reset input-reset-mobile"
                                    glyph="remove-circle" 
                                />
                                }
                            </Col>
                            <Col md={2} xs={2} style={{paddingLeft: 0, paddingRight: 0, textAlign: 'left'}}>
                                <Button
                                    type="submit"
                                    bsStyle="primary"
                                    onClick={this.props.handleSearchButton} 
                                    style={{width: '100%'}}>
                                    <FontAwesomeIcon icon={faSearch} />
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>
                {this.props.isMobileFilter && <Panel style={{ 
                    marginBottom: 0,
                    border: '0px solid transparent' 
                }}>
                    <Row>
                        <Col md={12} xs={12}>
                            <SiteSearchFilters
                                {...this.props.curriculum}
                                onFilterChange={this.props.handleFilterChange}
                                onFilterClear={this.props.handleFilterClear}
                                onCollectionClear={this.props.handleCollectionClear}
                                selectedCollection={this.props.selectedCollection}
                                isFilter={isFilter}
                            />
                            {this.props.showFrogPlayPopover &&
                                <FrogPlayPopover
                                    onClose={this.props.FrogPlayPopoverOnClose}
                                />
                            }
                            {this.props.showYearPopover &&
                                <YearPopover
                                    year={this.props.curriculum.selectedYear.name}
                                    onClose={this.props.YearPopoverOnClose}
                                />
                            }
                        </Col>
                    </Row>
                </Panel>}
            </div>
        );
    }
}